import React from 'react';
import AdminDashboard from '../mainMenu/adminDashboard';
import OwnerDashboard from '../owner/dashboard/index';
import { isOwnerScope } from '../../core/data/utils/roleScope';

const DashboardRouter = () => {
  return isOwnerScope() ? <OwnerDashboard /> : <AdminDashboard />;
};

export default DashboardRouter;
